/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { Row, Col, Table, message, Tooltip, Modal } from "antd";
import { SyncOutlined, PaperClipOutlined } from "@ant-design/icons";
import { APIs, getToken } from "../../../utils/worker";
import "./style.scss";
import axios from "axios";
import { showErrorMessage } from "../../../utils";
import attachmentIcon from "../../../assests/images/paperpin.svg";

const token = getToken();

const ViewBroadcast = (check) => {
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);

  const navigate = useNavigate();
  const tableLoading = {
    spinning: isTableLoading,
    indicator: <SyncOutlined spin />,
  };
  const columns = [
    {
      title: "Sl No",
      dataIndex: "slNo",
      key: "slNo",
      width: 10,
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      width: 25,
    },
    {
      title: "Valid From",
      dataIndex: "validFrom",
      key: "validFrom",
      width: 25,
    },
    {
      title: "Valid To",
      dataIndex: "validTo",
      key: "validTo",
      width: 25,
    },
    {
      title: "Message",
      dataIndex: "title",
      key: "title",
      width: 40,
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span
            className="broadcast-message"
            onClick={() => showMessage(record)}
            style={{ cursor: "pointer" }}
          >
            {text}
          </span>
          {getAttachmentUrl(record) && (
            <Tooltip title="View Attachment">
              <img
                width="25px"
                height="25px"
                style={{ cursor: "pointer" }}
                src={attachmentIcon}
                alt="attachment"
                onClick={() => showMessage(record)}
              />
            </Tooltip>
          )}
        </div>
      ),
    },
  ];

  useEffect(() => {
    getBroadcastList();
  }, [check]);

  const showMessage = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const isVideo = (url) => {
    if (!url) return false;
    // Match extensions even if followed by query params or fragments
    return url.match(/\.(mp4|webm|ogg|mov|avi)(\?|#|$)/i);
  };

  const isImage = (url) => {
    if (!url) return false;
    // Match extensions even if followed by query params or fragments
    return url.match(/\.(jpeg|jpg|gif|png|webp)(\?|#|$)/i);
  };

  const isPdf = (url) => {
    if (!url) return false;
    return url.match(/\.pdf(\?|#|$)/i);
  };

  const getFileName = (url) => {
    if (!url) return "";
    const parts = url.split("/");
    const name = parts[parts.length - 1].split("?")[0];
    return decodeURIComponent(name);
  };

  const cleanHtml = (html) => {
    if (!html) return "";
    return html.replace(/(<br\s*\/?>|&nbsp;|\s)+$/gi, "").replace(/<p>(&nbsp;|\s)*<\/p>$/gi, "");
  };

  const getAttachmentUrl = (record) => {
    let url = record?.filePath ||
      record?.file ||
      record?.fileUrl ||
      record?.file_path ||
      record?.attachmentUrl ||
      record?.attachment ||
      record?.mediaPath ||
      record?.media_path;

    if (!url && record?.message) {
      const srcMatch = record.message.match(/src=['"]([^'"]+)['"]/i);
      const hrefMatch = record.message.match(/href=['"]([^'"]+)['"]/i);
      url = srcMatch ? srcMatch[1] : (hrefMatch ? hrefMatch[1] : null);
    }
    return url;
  };

  const getBroadcastList = async () => {
    setIsTableLoading(true);
    try {
      let response = await axios.get(
        APIs.baseURL + "/broadcast-service/v1/broadcast",
        {
          headers: {
            Authorization: token,
            token: token.split("Bearer ")[1],
          },
        }
      );
      let temp = [];
      response?.data?.map((e, index) => {
        temp.push({
          slNo: index + 1,
          ...e
        });
      });
      setDataSource(temp);
      setIsTableLoading(false);
    } catch (error) {
      showErrorMessage(error.response.data.message);
      setIsTableLoading(false);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <a>Previous</a>;
    }
    if (type === "next") {
      return <a>Next</a>;
    }
    return (
      <div>
        <p>{originalElement} </p>
      </div>
    );
  };

  return (
    <div className="master-main-container profile-container">
      <div className="p-1">
        <p className="f-16 fw-500 title-color">Broadcast Message</p>
        <hr className="divider" />
        <Table
          className="table-head-sticky"
          columns={columns}
          dataSource={dataSource}
          loading={tableLoading}
          pagination={{
            itemRender: itemRender,
          }}
        />
      </div>
      <Modal
        title={selectedRecord?.title}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={false}
        width={650}
        className="square-modal"
      >
        <div className="modal-content-wrapper">
          <div
            className="message-content"
            dangerouslySetInnerHTML={{ __html: cleanHtml(selectedRecord?.message) }}
          ></div>
          {getAttachmentUrl(selectedRecord) && (
            <div className="media-preview">
              {isVideo(getAttachmentUrl(selectedRecord)) ? (
                <video
                  key={getAttachmentUrl(selectedRecord)}
                  width="100%"
                  controls
                  autoPlay
                  muted
                  playsInline
                  src={getAttachmentUrl(selectedRecord)}
                  style={{ borderRadius: "8px" }}
                >
                  Your browser does not support the video tag.
                </video>
              ) : isImage(getAttachmentUrl(selectedRecord)) ? (
                <img
                  src={getAttachmentUrl(selectedRecord)}
                  alt="Attachment"
                  style={{ maxWidth: "100%", borderRadius: "8px" }}
                />
              ) : isPdf(getAttachmentUrl(selectedRecord)) ? (
                <iframe
                  src={getAttachmentUrl(selectedRecord)}
                  width="100%"
                  height="400px"
                  style={{ border: "none", borderRadius: "8px" }}
                  title="PDF Preview"
                >
                  Your browser does not support iframes.
                  <a href={getAttachmentUrl(selectedRecord)} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                </iframe>
              ) : (
                <div className="file-attachment text-center">
                  <a href={getAttachmentUrl(selectedRecord)} target="_blank" rel="noopener noreferrer">
                    View Attachment
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};
export default ViewBroadcast;
